import { useMemo } from 'react';

import { useQueries } from '@tanstack/react-query';
import { getExpressionParamWithData } from 'config/requests/gatewayRules';
import { useExpressionParams } from 'pages/GatewayRules/hooks';

export function useInitialCreateExpression(aliases = ['currency']) {
  const { expressionParams } = useExpressionParams();

  const queries = useQueries({
    queries: aliases.map((alias) => ({
      queryKey: ['expressionParamWithData', alias],
      queryFn: () => getExpressionParamWithData(alias),
    })),
  });

  const isPending = queries.some((q) => q.isPending);

  const expressionParamsMap = useMemo(
    () => Object.fromEntries((expressionParams ?? []).map((p) => [p.alias, p])),
    [expressionParams],
  );

  const initialCreateExpressions = useMemo(() => {
    if (isPending) {
      return [];
    }

    return aliases.map((alias, i) => {
      const data = queries[i].data;

      return {
        expressionParam: expressionParamsMap[alias],
        comparisonOperator: data?.comparisonOperators?.[0]?.id
          ? `/admin/comparison_operators/${data.comparisonOperators[0].id}`
          : undefined,
        value: [],
      };
    });
  }, [aliases, queries, expressionParamsMap, isPending]);

  return { initialCreateExpressions, isPending };
}
